import { SideNavLayout } from "@layouts/SideNavLayout";
import { SystemEnvRoutes } from "modules/system/sections/env/SystemEnvRoutes";
import { SystemEnvSections } from "modules/system/sections/env/SystemEnvSections";

export const SystemEnv = () => (
  <SideNavLayout nav={<SystemEnvSections />}>
    <SystemEnvRoutes />
  </SideNavLayout>
);
